<template>
  <div>
    <div v-if="group.type == 'ACADEMIC' && !isEmpty(group.schedules)">
      <div class="columns is-vcentered is-mobile">
        <div class="column is-narrow">
          <i class="fas fa-calendar fa-lg"></i>
        </div>
        <div class="column">
          <span><h3 class="title is-5">Jadwal Kuliah</h3></span>
        </div>
        <div class="column is-narrow is-hidden-tablet">
          <a
            class=""
            @click="open = !open"
            aria-controls="contentIdForA11y1"
          >
            <i class="fas fa-caret-up" v-if="open"></i>
            <i class="fas fa-caret-down" v-else></i>
          </a>
        </div>
      </div>

      <b-collapse v-if="open" :open="open" aria-id="contentIdForA11y1" class="card-detail-right animated fadeInUp" style="color: #4a4a4a;">
        <div class="column is-12-fullhd is-12-widescreen is-12-desktop is-12-tablet is-12-mobile">
          <div class="card-anggota">
            <div>
              <div class="field is-horizontal" v-for="(schedule, key) in group.schedules" :key="key">
                <div class="field-label"><strong>{{ schedule.day }}: </strong></div>
                <div class="field-body has-text-right">
                  <div class="control">
                    {{ schedule.start }} - {{ schedule.end }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <br v-if="group.type == 'ACADEMIC' && !isEmpty(group.schedules)">
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: true
    },
    group: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      open: this.isOpen
    }
  }
}
</script>
